export default __webpack_public_path__ + "static/media/cm-2.f87fa794.jpg";